import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/icons/x-icon.png")